var React = require('react');

function BubbleInverted (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-2.9-3.1v300.9h248.8V-3.1H-2.9z M131.6,289.5c-9.6,3.5-18.8,5.3-27.2,5.3c-8.5,0-16.3-1.8-23.1-5.4\n\tc-12.2-6.5-20.8-18.6-24.8-35c-2.7-11.1-3.6-25.2-2.8-38.9C25,198.5,0.6,167.4,0,123.1c-0.4-32.8,12-63.7,35-87\n\tC58,12.8,88.8,0,121.5,0C188.5,0,243,54.5,243,121.5C243,197.6,198.2,265.1,131.6,289.5z"}));
}

BubbleInverted.defaultProps = {"fill":"none","x":"0px","y":"0px","viewBox":"0 0 243 294.8","style":{"enableBackground":"new 0 0 243 294.8"},"xmlSpace":"preserve"};

module.exports = BubbleInverted;

BubbleInverted.default = BubbleInverted;
